export class NotFound {
  constructor(public uri: string) {}

  toString(): string {
    return 'Объект не найден';
  }
}
